const state = {
    user: {},
}

const getters = {
    currentUser: (state) => (customerId) => state.user ? state.user[customerId] : null,
}

const actions = {
  
    async SetCurrentUser({ commit }, { user, customerId } ) {
        commit('setCurrentUser',  { user, customerId })
    },

    async LogOut({ commit }, { customerId }) {
        commit('logout', customerId)
    },

}

const mutations = {
    setCurrentUser(state,  { user, customerId }) {
        if (!state.user) {
            state.user = {}
        }
        state.user[customerId] = user
    },
    logout(state, customerId) {
        if (!state.user) {
            state.user = {}
        }
        state.user[customerId] = null
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
